// MIGRATED FROM: Solar API only
// MIGRATION DATE: 2024-08-25
// CHANGE TYPE: STANDARD - Solar API implementation
// BACKWARD COMPATIBLE: Yes - All existing district filter methods preserved

import { AxiosInstance } from 'axios'

import { buildApiEndpoint, createSolarApiClient } from '@/shared/libs/api-client'
import { localeToCountryCode, type CountryCodes } from '@/utils/language'

export interface DistrictsResponse {
  cityList: DistrictCity[]
}

export interface DistrictCity {
  code: string
  name: string
  neighborhoodVicinityList: DistrictNeighborhoodVicinity[]
}

export interface DistrictNeighborhoodVicinity {
  id: string
  name: string
  isPreparing: boolean
}

export interface DistrictRequestParams {
  country: CountryCodes
}

export class DistrictFilterService {
  constructor(private readonly apiClient: AxiosInstance) {}

  async getAllDistricts(country: CountryCodes): Promise<DistrictsResponse> {
    const config = buildApiEndpoint(
      {
        method: 'GET',
        url: '/search/filters/districts',
        params: { country },
      },
      'solar',
    )

    const response = await this.apiClient.request<DistrictsResponse>(config)
    return response.data
  }
}

export const clientDistrictFilterService = new DistrictFilterService(createSolarApiClient())
